import TwoColumn from "./TwoColumn";
import TitleThreeColumn from "./TitleThreeColumn";
import Center from "./Center";
import LeftAlignTwoColumn from "./LeftAlignTwoColumn";
import Form from "./Form";
import Note from "./Note";
import Faq from "./Faq";
import React from "react";

export function createViewArray(viewData, path, props) {
  if (viewData) {
    return viewData.map((view, idx) => {
      switch (view.type) {
        case "TwoColumn":
          return <TwoColumn key={path + view.type + idx} columnsData={view} />;
        case "TitleThreeColumn":
          return (
            <TitleThreeColumn key={path + view.type + idx} columnsData={view} />
          );
        case "Center":
          return (
            <Center key={path + view.type + idx} data={view} props={props} />
          );
        case "LeftAlignTwoColumn":
          return (
            <LeftAlignTwoColumn key={path + view.type + idx} data={view} />
          );
        case "Form":
          if (props && props.email) {
            return <Form key={path + view.type + idx} data={view} {...props} />;
          } else {
            return null;
          }
        case "Note":
          return <Note key={path + view.type + idx} data={view} />;
        case "Faq":
          return <Faq key={path + view.type + idx} data={view} />;
        default:
          return <div key={path + view.type + idx}></div>;
      }
    });
  } else {
    return (
      <div>
        <h1>404</h1>
      </div>
    );
  }
}
